var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      attrs: {
        id: "mycourses",
      },
    },
    [
      _vm.isEmpty
        ? _c(
            "studip-message-box",
            {
              attrs: {
                type: "info",
                hideClose: true,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "details",
                    fn: function fn() {
                      return [
                        _c("ul", [
                          _c(
                            "li",
                            {
                              directives: [
                                {
                                  name: "translate",
                                  rawName: "v-translate",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                    Sie haben zur Zeit keine Veranstaltungen belegt, an denen Sie teilnehmen können.\n                    "
                              ),
                              _c("br"),
                              _vm._v("\n                    Bitte nutzen Sie "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.searchCoursesUrl,
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v("Veranstaltung suchen / hinzufügen"),
                                  ]),
                                ]
                              ),
                              _vm._v(
                                " um sich für Veranstaltungen anzumelden.\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              directives: [
                                {
                                  name: "translate",
                                  rawName: "v-translate",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                    In dem ausgewählten "
                              ),
                              _c("strong", [_vm._v("Semester")]),
                              _vm._v(
                                " wurden keine Veranstaltungen belegt.\n                    "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                    Wählen Sie links im "
                              ),
                              _c("strong", [_vm._v("Semesterfilter")]),
                              _vm._v(
                                " ein anderes Semester aus!\n                "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                512192912
              ),
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$gettext("Es wurden keine Veranstaltungen gefunden.")
                  ) +
                  "\n        " +
                  _vm._s(_vm.$gettext("Mögliche Ursachen:")) +
                  "\n        "
              ),
            ]
          )
        : _c(_vm.displayComponent, {
            tag: "component",
            attrs: {
              "icon-size": _vm.iconSize,
            },
          }),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            "mount-to":
              "#tiled-courses-sidebar-switch .sidebar-widget-content .widget-list",
            name: "sidebar-switch",
          },
        },
        [_c("my-courses-sidebar-switch")],
        1
      ),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            "mount-to":
              "#tiled-courses-new-contents-toggle .sidebar-widget-content .widget-list",
            name: "sidebar-content-toggle",
          },
        },
        [_c("my-courses-new-content-toggle")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }